import {
  Container,
  Content,
  FlexDiv,
  FlexEndSpacedDiv,
  Header,
  Link,
  NavBar,
  NavBarOrientation
} from '@elhub/ds-components'
import LogoGreen from '@elhub/ds-logos/logos/png/elhub_logo_green.png'
import LogoWhite from '@elhub/ds-logos/logos/png/elhub_logo_white.png'
import i18n from 'locales/i18n'
import { useAppSelector } from 'store'
import styled from 'styled-components'

import React, { PropsWithChildren, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import useWindowSize from 'hooks/useWindowSize'

import { LabelMessages } from '../../locales/messages/label'

import _ from 'lodash'

const Body = styled.div`
  flex: 1 1 auto;
`

const CenteredDiv = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 100vw;
`

const Footer = styled(Header)`
  display: flex;
  padding: 0.5rem;
  align-items: center;
  justify-content: center;
`

const Logo = styled.img`
  max-height: 30px;
  max-width: 80px;
  flex: 1;
  margin-top: 0.5rem;
  margin-right: 0.5rem;
`

const TopContainer = ({ children }: PropsWithChildren<{}>) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { theme, language }: any = useAppSelector((state) => ({
    theme: state.app.theme,
    language: state.app.language
  }))
  const dimensions = useWindowSize()
  const [orientation, setOrientation] = useState<NavBarOrientation>('horizontal')

  useEffect(() => {
    if (_.isNumber(dimensions.width)) {
      if (dimensions.width <= 768 && orientation !== 'vertical') {
        setOrientation('vertical')
      } else if (dimensions?.width > 768 && orientation !== 'horizontal') {
        setOrientation('horizontal')
      }
    }
  }, [dimensions, orientation])

  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language])

  /*  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setLanguage(e.target.value as AllowedLanguages))
  }
*/

  const navbarActive = ['intro', 'energy-data-api', 'data-export-api', 'downloads', 'maskinporten', 'change-logs', 'try-it-out'].indexOf(window.location.pathname.split('/')[1])

  // @ts-ignore
  return (
    <>
      <Container data-theme={theme}>
        <Header>
          <Body>
            <FlexDiv style={{ justifyContent: 'center' }}>
              <Content style={{ maxWidth: '1200px', padding: 0, paddingTop: '0.3rem' }}>
                <FlexEndSpacedDiv style={{ padding: '0rem 0.5rem' }}>
                  <NavBar
                    defaultValue={navbarActive}
                    size='small'
                    style={{ alignItems: 'baseline' }}
                    orientation={orientation}
                  >
                    <Logo
                      alt='logo'
                      style={{ marginRight: '1rem', cursor: 'pointer' }}
                      src={theme === 'light' ? LogoGreen : LogoWhite}
                      onClick={() => (window.location.href = 'https://elhub.no/')}
                    />
                    <NavBar.Link style={{ marginTop: '1rem' }} onClick={() => navigate('/intro')}>
                      {t(LabelMessages.INTRODUCTION)}
                    </NavBar.Link>
                    {/* <NavBar.Link onClick={() => navigate('/auth')}>
                      {t('label:authentication')}
                    </NavBar.Link> */}
                    <NavBar.Link onClick={() => navigate('/energy-data-api')}>{t(LabelMessages.ENERGY_DATA_API)}</NavBar.Link>
                    <NavBar.Link onClick={() => navigate('/data-export-api')}>{t(LabelMessages.DATA_EXPORT_API)}</NavBar.Link>
                    <NavBar.Link onClick={() => navigate('/downloads')}>{t(LabelMessages.Downloads)}</NavBar.Link>
                    <NavBar.Link onClick={() => navigate('/maskinporten')}>
                      {t(LabelMessages.MASKINPORTEN)}
                    </NavBar.Link>
                    <NavBar.Link onClick={() => navigate('/change-logs')}>{t(LabelMessages.CHANGE_LOG)}</NavBar.Link>
                    <NavBar.Link onClick={() => navigate('/try-it-out')}>{t(LabelMessages.TRY_IT_OUT)}</NavBar.Link>
                  </NavBar>
                  {/* <FlexEndDiv style={{ paddingBottom: '0.5rem' }}> */}
                  {/* <ThemeButton
                      icon={theme === 'light' ? <LightMode size='1.5rem' /> : <DarkMode size='1.5rem' />}
                      data-testid='Header-ThemeButton'
                      onClick={toggleTheme}
                    /> */}
                  {/* <HorizontalSpace />
              <Select size='small' hideLabel value={language} onChange={handleLanguageChange}>
                <option value='en'>English</option>
                <option value='nb'>Norsk bokmål</option>
              </Select> */}
                  {/* </FlexEndDiv> */}
                </FlexEndSpacedDiv>
              </Content>
            </FlexDiv>
          </Body>
        </Header>
        <Body>
          <FlexDiv>
            <CenteredDiv>{children}</CenteredDiv>
          </FlexDiv>
        </Body>
        <Footer>
          Elhub, 2023 &nbsp;|&nbsp;
          {/* <Link variant='secondary' href='#' onClick={() => navigate('/terms-of-use')}>
            {t('label:terms-of-use')}
          </Link>
          &nbsp;|&nbsp; */}
          <Link variant='secondary' href='mailto:post@elhub.no'>
            Contact
          </Link>
        </Footer>
      </Container>
    </>
  )
}

export default TopContainer
